import { z } from 'zod';
export const InvoicingParameterSchema = z.enum(['INVOICING_BASE_URL']);
export const InvoicingParameterEnum = InvoicingParameterSchema.enum;
